import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Point from 'ol/geom/Point';
import Circle from 'ol/geom/Circle';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import Feature from 'ol/Feature';
import LayerGroup from 'ol/layer/Group';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import colors from 'dxf/src/util/colors';
import proj4 from 'proj4';
import Featuredrawer from './FeatureDrawer'

var dbVersion = 2;

export default class HeightMapDrawer {
    static async drawHeightmap(data, dark, projection, mapprojection, setting = null) {
        if (setting == null) {
            setting = {
                colorMin: null,
                colorMax: null,
                offset: null
            };
        }

        var featureDrawer = new Featuredrawer(projection, mapprojection)

        return new Promise(resolve => {
            console.log("start heightmap drawing");
            var component = this;
            var minHeight = setting.colorMin ?? data.minHeight;
            var maxHeight = setting.colorMax ?? data.maxHeight;
            var offset = setting.offset ?? 0;

            var open = indexedDB.open("HEIGHTMAP", dbVersion);
            open.onerror = event => {
                console.log("ERROR:")
                console.log(event)
                resolve(null);
            };
            open.onsuccess = function () {
                console.log("OPENED INDEXDB")
                var db = open.result;
                var tx = db.transaction("Vertexes", "readonly");
                var store = tx.objectStore("Vertexes");

                var features = [];
                // var textFeatures = [];
                var vertexList = [];
                store.openCursor().onsuccess = function (event) {
                    var vertex = event.target.result;

                    if (vertex) {
                        if ((vertex.value.height + offset) >= minHeight && (vertex.value.height + offset) <= maxHeight) {
                            vertexList.push(vertex.value);
                            // var vertexP = proj4.transform(sourceproj, destproj, [vertex.value.position.x, vertex.value.position.y]);
                            // var point = new Point([vertexP.x, vertexP.y], 2);
                            // var feature = new Feature(point);
                            // feature.set('height', vertex.value.height + offset);
                            // features.push(feature);
                        }
                        vertex.continue();
                    } else {
                        console.log('Entries all displayed.');

                        //moved code here so it can be sorted on height before moving it to features array
                        vertexList.sort(function (a, b) { return (a.height * 100000) - (b.height * 100000) });
                        vertexList.forEach(vertex => {

                            var feature = featureDrawer.drawFeature({ type: "POINT", x: vertex.position.x, y: vertex.position.y })

                            feature.set('height', vertex.height + offset);
                            features.push(feature);
                        });

                        var layerGroup = new LayerGroup({
                            id: 'heightmapGroup',
                            layers: []
                        });
                        var heightSource = new VectorSource();
                        heightSource.addFeatures(features);
                        var heatmapLayer = new WebGLPointsLayer({
                            source: heightSource,
                            style: {
                                "circle-radius": ['clamp', ["/", 2, ["resolution"]], 10, 150],
                                "circle-fill-color": [
                                    'interpolate',
                                    ['linear'],
                                    ['get', 'height'],
                                    minHeight,
                                    '#00FF00',
                                    (minHeight + maxHeight) / 2,
                                    '#FFFF00',
                                    maxHeight,
                                    '#FF0000'],
                            },
                            zIndex: 201
                        });

                        var heatmapTextLayer = new VectorLayer({
                            title: "numbers",
                            source: heightSource,
                            style: function (feature, resolution) {
                                var newScale = 0.07 / resolution;
                                if (newScale > 9) {
                                    newScale = 9;
                                }
                                var height = feature.get('height');
                                var color = colors[dark ? 7 : 0];
                                var style = new Style({
                                    text: new Text({
                                        text: component.formatAsCm(height).toFixed(1),
                                        textAlign: "center",
                                        offsetX: 0,
                                        offsetY: 2,
                                        scale: newScale,
                                        fill: new Fill({
                                            color: color,
                                        }),
                                    })
                                });
                                return style;
                            },
                            minZoom: 20,
                            zIndex: 202,
                        });
                        layerGroup.getLayers().push(heatmapLayer);
                        layerGroup.getLayers().push(heatmapTextLayer);

                        // Note: if we don't need to redraw the heightmap we can clear it. But because on civil we want to change the colors we need to keep the data to redraw it
                        //store.clear();
                        resolve(layerGroup);
                    }

                    // Close the db when the transaction is done
                    tx.oncomplete = function () {
                        db.close();
                    };
                };

            };
            open.onblocked = e => {
                console.log(e);
                resolve(null);
            };
            open.onupgradeneeded = e => {
                console.log(e);
                resolve(null);
            };


        });
    }

    static clear() {
        var open = indexedDB.open("HEIGHTMAP", dbVersion);
        open.onsuccess = function () {
            var db = open.result;
            var tx = db.transaction("Vertexes", "readwrite");
            var store = tx.objectStore("Vertexes");
            store.clear();
        }
    }

    static formatAsCm(meter) {
        meter = meter * 100;
        return Math.round(meter * 10) / 10;
    }
    /*
     
     */
}
